export default "__VITE_ASSET__B7_oQjFS__ 400w, __VITE_ASSET__J86$cAcX__ 800w, __VITE_ASSET__BgzNJsIf__ 1280w";